import { iframeResizerId } from '@src/constants/iframe';

export function attachHubspotListeners() {
  global.window.addEventListener('message', (event) => {
    if (event.data.key === 'redirect')
      global.window.location = event.data.value;

    if (event.data.key === 'goBack')
      global.window.location.href = document.referrer;

    if (event.data.key === 'scrollTo') {
      const iframeOffset = document.querySelector(iframeResizerId).offsetTop;
      const elementOffset = event.data.value;

      global.window.scrollTo({ top: iframeOffset + elementOffset, behavior: 'smooth' });
    }

    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
      global.window.mixpanel.track('Form Submitted', {
        form_id : event.data.id,
      });
    }
  });
}
